export enum PlatformsEnum {
  DEFAULT,
  ECAPTUREDTECH,
  EYESCLOUD3D,
  EYESNROAD,
  EYESDCAR,
}
